import { render } from "./_MobileNavigation.vue?vue&type=template&id=79be53ae&scoped=true&lang=en"
import script from "./_MobileNavigation.vue?vue&type=script&lang=js"
export * from "./_MobileNavigation.vue?vue&type=script&lang=js"

import "./_MobileNavigation.vue?vue&type=style&index=0&id=79be53ae&lang=scss&scoped=true"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79be53ae"]])

export default __exports__